
import { Button } from "@/components/ui/button";
import { Calendar, Scan, Star } from "lucide-react";

export const CoreFeaturesSection = () => {
  return (
    <div className="py-24 px-6 bg-gray-900/50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-16">
          Core Features Available Now
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <div className="p-8 rounded-xl bg-gray-900 border-2 border-purple-500/30 shadow-[0_0_30px_rgba(139,92,246,0.15)]">
            <Calendar className="w-12 h-12 text-purple-400 mb-4" />
            <h3 className="text-2xl font-semibold text-white mb-4">Create & Manage Events</h3>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-center gap-2">
                <Star className="w-5 h-5 text-purple-400" />
                List events, sell tickets, and track attendance
              </li>
              <li className="flex items-center gap-2">
                <Star className="w-5 h-5 text-purple-400" />
                QR-code ticketing for seamless entry
              </li>
              <li className="flex items-center gap-2">
                <Star className="w-5 h-5 text-purple-400" />
                Auto-sync guest lists
              </li>
            </ul>
          </div>
          <div className="p-8 rounded-xl bg-gray-900 border-2 border-purple-500/30 shadow-[0_0_30px_rgba(139,92,246,0.15)]">
            <Scan className="w-12 h-12 text-purple-400 mb-4" />
            <h3 className="text-2xl font-semibold text-white mb-4">ID Scanning & Security</h3>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-center gap-2">
                <Star className="w-5 h-5 text-purple-400" />
                ScanTek API integration for ID verification
              </li>
              <li className="flex items-center gap-2">
                <Star className="w-5 h-5 text-purple-400" />
                ClubMate Digital ID for non-ScanTek venues
              </li>
              <li className="flex items-center gap-2">
                <Star className="w-5 h-5 text-purple-400" />
                Instant ban list & VIP detection
              </li>
            </ul>
          </div>
        </div>
        <div className="text-center">
          <Button
            size="lg"
            className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white rounded-full px-8 shadow-[0_0_15px_rgba(139,92,246,0.5)] hover:shadow-[0_0_25px_rgba(139,92,246,0.65)] transition-all duration-300"
          >
            Set Up Your First Event Now
          </Button>
        </div>
      </div>
    </div>
  );
};
